import script from "./github-steps.vue?vue&type=script&setup=true&lang=ts"
export * from "./github-steps.vue?vue&type=script&setup=true&lang=ts"

import "./github-steps.vue?vue&type=style&index=0&id=21ecec00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ecec00"]])

export default __exports__